import { mergeStates } from '../iwProvider/StoreHelper';
import {
    BLOCK_ROUTER,
    CHANGE_ROUTER,
    REPLACE_ROUTER,
    UNBLOCK_ROUTER
} from './IwRouter.actions';

const initialState = {
    routerBlocked: false
};

// eslint-disable-next-line import/no-default-export
export default function (state = mergeStates(initialState), action = {}) {
    switch (action.type) {
        case CHANGE_ROUTER:
        case REPLACE_ROUTER:
            return mergeStates(state, {
                impersonatingStateKey: action.impersonatingStateKey
            });

        case BLOCK_ROUTER:
            return mergeStates(state, {
                routerBlocked: true
            });

        case UNBLOCK_ROUTER:
            return mergeStates(state, {
                routerBlocked: false
            });

        default:
            return state;
    }
}
